﻿import type { RouteLocationNormalized, RouteLocationAsPathGeneric, RouteLocationAsRelativeGeneric } from "vue-router";

import {reactive, ref} from "vue";

export interface LoginRequest {
    username: string | undefined;
    password: string | undefined;
    remember?: boolean | undefined;
}

export enum AuthProvider{
    Integrated = "Integrated",
    AzureActiveDirectory = "AAD",
    Google = "Google"
}

export interface AunoaOptions {
    auth: {
        loginRoute: Partial<RouteLocationAsRelativeGeneric>;
        logoutRoute: Partial<RouteLocationAsRelativeGeneric>;
        registerRoute: Partial<RouteLocationAsRelativeGeneric>;
        resetPasswordRoute: Partial<RouteLocationAsRelativeGeneric>;
        changePasswordRoute: Partial<RouteLocationAsRelativeGeneric>;
        reloginPromise(loginRequest: LoginRequest): Promise<any>;
        authProvider: AuthProvider,
    };
}

const options = reactive<AunoaOptions>({
    auth: {
        loginRoute: undefined,
        logoutRoute: undefined,
        registerRoute: undefined,
        resetPasswordRoute: undefined,
        changePasswordRoute: undefined,
        reloginPromise: (loginRequest: LoginRequest) => Promise.reject("Missing Relogin Promise in Aunoa Options"),
        authProvider: AuthProvider.Integrated,
    },
})


export const useAunoaOptions = () => {
    return {
        options
    }
};
